var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewApplication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CF817E;}\n\t.st1{fill:#F8DDE6;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-260.2,390.1h-27.4v-8.4h27.4V390.1z M-286.1,388.6h24.4v-5.4h-24.4V388.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -268.6,
    y: 385.2,
    className: "st0",
    width: 1.5,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -265.1,
    y: 385.2,
    className: "st0",
    width: 1.5,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -283.9,
    y: 385.2,
    className: "st0",
    width: 3.9,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-270.1,407.1h-17.5v-18.5h27.4v14.5l-1.3-1.2c-1-0.9-2.2-1.5-3.6-1.5c-2.8,0-5.2,2.3-5.2,5.2 c0,0.2,0,0.4,0,0.6L-270.1,407.1z M-286.1,405.6h14.4c0-3.7,3-6.6,6.7-6.6c1.2,0,2.4,0.3,3.4,0.9v-9.8h-24.5V405.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-260.9,401.4c-1.1-1-2.5-1.7-4.1-1.7c-3.3,0-5.9,2.6-5.9,5.9c0,0.2,0,0.5,0.1,0.7c0.4,2.9,2.8,5.2,5.9,5.2 c3.3,0,5.9-2.6,5.9-5.9C-259.2,403.9-259.8,402.4-260.9,401.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-265.1,412.2c-3.4,0-6.2-2.5-6.6-5.8c0-0.3-0.1-0.5-0.1-0.8c0-3.7,3-6.7,6.7-6.7c1.7,0,3.4,0.7,4.6,1.9 c1.3,1.3,2,3,2,4.8C-258.4,409.3-261.4,412.2-265.1,412.2z M-265.1,400.4c-2.8,0-5.2,2.3-5.2,5.2c0,0.2,0,0.4,0,0.6 c0.3,2.6,2.5,4.5,5.1,4.5c2.8,0,5.2-2.3,5.2-5.2c0-1.4-0.6-2.7-1.6-3.7C-262.4,401-263.7,400.4-265.1,400.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -265.8,
    y: 401.7,
    className: "st0",
    width: 1.5,
    height: 7.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -269,
    y: 404.8,
    className: "st0",
    width: 7.8,
    height: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewApplication);
export default __webpack_public_path__ + "static/media/new_application.97bb1e6c3f8595b98d3aa9160e69e4f5.svg";
export { ForwardRef as ReactComponent };